<template lang="pug">
  .history-size
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.active || dataOriginal.active === false")
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistorySize',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-size
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/size/History.vue